import { apiClient } from "./client";
import { AppNotification } from "../interfaces";

export const notificationsApi = {
  // Get all notifications for the current user
  getAll: (): Promise<AppNotification[]> => {
    return apiClient.get<AppNotification[]>(`/v1/notifications`);
  },

  // Mark a specific notification as read
  markAsRead: (id: string): Promise<void> => {
    return apiClient.patch<void>(`/v1/notifications/${id}/read`, {});
  },

  // Mark all notifications as read
  markAllAsRead: (): Promise<void> => {
    return apiClient.patch<void>(`/v1/notifications/read-all`, {});
  },

  // Delete a specific notification
  delete: (id: string): Promise<void> => {
    return apiClient.delete<void>(`/v1/notifications/${id}`);
  },

  // Delete all notifications
  deleteAll: (): Promise<void> => {
    return apiClient.delete<void>(`/v1/notifications/all`);
  },
};
